var e = function e(t, r) {
  if (t === null || Number.isNaN(t)) return "";
  var n = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: r,
    minimumFractionDigits: 0
  }),
      o = Math.floor(Math.abs(t));
  return n.format(o);
};

export { e as formatValue };